import dayjs from 'dayjs'
import { addUserOperateRecord } from '@/api/user.js'
import store from '@/store'

// 根据path查找菜单，返回菜单所有菜单title
const findMenuTitle = (menuList, path) => {
  const search = (items, parentTitles = []) => {
    for (const { path: itemPath, title, submenu } of items) {
      if (itemPath === path) return [...parentTitles, title]
      if (submenu && Array.isArray(submenu)) {
        const subResult = search(submenu, [...parentTitles, title])
        if (subResult.length) return subResult
      }
    }
    return []
  }

  return search(menuList).length ? search(menuList) : null
}

const generateRandomString = (length = 8) => {
  const chars =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const stringLength = length
  let randomString = ''
  for (let i = 0; i < stringLength; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length)
    randomString += chars[randomIndex]
  }
  return randomString
}

const getQueryParams = (url) => {
  const params = {}
  const urlObj = new URL(url)
  const queryParams = new URLSearchParams(urlObj.search)

  queryParams.forEach((value, key) => {
    params[key] = value
  })

  return params
}

const generateSecret = (length) => {
  if (!length || length == null) {
    length = 1
  }
  const l = length > 10 ? 10 : length
  const str = Math.random().toString(36).substr(2, l)
  if (str.length >= length) {
    return str
  }
  return str.concat(generateSecret(length - str.length))
}

const formatISODate = (isoString) => {
  if (!isoString) return ''
  return dayjs(isoString).format('YYYY-MM-DD')
}

const transformToTree = (data) => {
  function processNode(node) {
    // 如果是数组，继续处理数组中的元素
    if (Array.isArray(node)) {
      if (node.length) {
        return node.map(item => processNode(item)).flat() // 扁平化数组
      } else {
        return null
      }
    } else if (typeof node === 'object' && node !== null) {
      // 如果是对象，则递归处理每个键值对
      return Object.entries(node).map(([key, value]) => ({
        label: key,
        value: key,
        children: processNode(value)
      }))
    }

    // 如果是基本类型（例如字符串），将其直接作为节点的label
    return [{
      label: node, // 基础数据类型的子节点为空数组
      value: node
    }]
  }

  return processNode(data)
}

const addUserOperateRecordFn = async(option) => {
  console.log('addUserOperateRecord', store.getters.orgList)
  const params = {
    ...option, //
    operaterId: store.state.user.userInfo?.id.id || '', // 用户id
    operaterOrgId: store.getters.orgList[0]?.id || '', // 用户所属组织id（如果有切换组织功能，这边需要修改）
    operaterRoleId: store.getters.roleList[0]?.roleId || '', // 用户角色id
    operaterCustomerId: store.getters.customerInfo?.customerId || '' // 用户所属客户id
  }
  await addUserOperateRecord(params)
}

// 导出-公用
const exportFiles = (data, name) => {
  const fileReader = new FileReader()
  fileReader.readAsDataURL(data)
  fileReader.onload = (event) => {
    const a = document.createElement('a')
    a.download = name
    a.href = event.target.result
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

const filterMenuDataFn = (menuData, menuList) => {
  return menuData.reduce((acc, item) => {
    // 检查当前菜单项是否符合过滤条件
    if (item.meta.requiredPermissions.some(permission => menuList.includes(permission))) {
      // 如果有子菜单，递归过滤子菜单
      let filteredSubmenu = null
      if (item.submenu) {
        filteredSubmenu = filterMenuDataFn(item.submenu, menuList)
      }
      // 如果子菜单经过过滤后不为空，或者当前菜单项没有子菜单，则保留当前菜单项
      if (filteredSubmenu && filteredSubmenu.length > 0 || !item.submenu) {
        acc.push({
          ...item,
          ...(filteredSubmenu && { submenu: filteredSubmenu }) // 只有当存在过滤后的子菜单时才添加
        })
      }
    }
    return acc
  }, [])
}

const getFirstValidPath = (menuItems) => {
  for (const item of menuItems) {
    if (item.submenu && item.submenu.length > 0) {
      // 如果有子菜单，递归查找子菜单中的第一个有效路径
      return getFirstValidPath(item.submenu)
    } else {
      // 返回当前菜单项的路径
      return item.path
    }
  }
  return null // 如果没有有效的菜单项，返回null
}

const thousandsSeparator = (value) => {
  if (!value) return ''
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const getQueryobject = (url) => {
  url = url == null ? window.location.href : url
  console.log(url,'url-----G5')
  if(url.indexOf('?') > -1){
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) =>{
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
    }     
}
export { findMenuTitle, generateRandomString, getQueryParams, generateSecret, formatISODate, transformToTree, addUserOperateRecordFn, exportFiles, filterMenuDataFn, getFirstValidPath, thousandsSeparator,getQueryobject }
